import { Geometry } from '@antv/g2';
import { each } from '@antv/util';
import { interaction, theme, state } from '../../adaptor/common';
import { Params } from '../../core/adaptor';
import { flow, pick } from '../../utils';
import { polygon, edge } from '../../adaptor/geometries';
import { chordLayout } from '../../utils/transform/chord';
import { getAllGeometriesRecursively, transformDataToNodeLinkData } from '../../utils';
import { ChordOptions } from './types';
import { X_FIELD, Y_FIELD, NODE_COLOR_FIELD, EDGE_COLOR_FIELD } from './constant';

function transformData(params: Params<ChordOptions>): Params<ChordOptions> {
  // å°å¼¦å¾æ°æ®æ¾å°extä¸­ï¼nodeGeometry edgeGeometryä½¿ç¨

  const { options } = params;
  const { data, sourceField, targetField, weightField, nodePaddingRatio, nodeWidthRatio, rawFields = [] } = options;

  // å°æ°æ®è½¬æ¢ä¸ºnode linkæ ¼å¼
  const chordLayoutInputData = transformDataToNodeLinkData(data, sourceField, targetField, weightField);

  const { nodes, links } = chordLayout({ weight: true, nodePaddingRatio, nodeWidthRatio }, chordLayoutInputData);

  // 1. çæç»å¶nodeä½¿ç¨æ°æ®
  const nodesData = nodes.map((node) => {
    return {
      ...pick(node, ['id', 'x', 'y', 'name', ...rawFields]),
      isNode: true,
    };
  });

  // 2. çæ edge ä½¿ç¨æ°æ® ï¼åæ¡åºå¾ï¼
  const edgesData = links.map((link) => {
    return {
      source: link.source.name,
      target: link.target.name,
      name: link.source.name || link.target.name,
      ...pick(link, ['x', 'y', 'value', ...rawFields]),
      isNode: false,
    };
  });

  return {
    ...params,
    ext: {
      ...params.ext,
      // å°chordDataæ¾å°extä¸­ï¼æ¹ä¾¿ä¸é¢çgeometryä½¿ç¨
      chordData: { nodesData, edgesData },
    },
  };
}

/**
 * scaleéç½®
 * @param params åæ°
 */
function scale(params: Params<ChordOptions>): Params<ChordOptions> {
  const { chart } = params;
  chart.scale({
    x: { sync: true, nice: true },
    y: { sync: true, nice: true, max: 1 },
    [NODE_COLOR_FIELD]: { sync: 'color' },
    [EDGE_COLOR_FIELD]: { sync: 'color' },
  });
  return params;
}

/**
 * axiséç½®
 * @param params åæ°
 */
function axis(params: Params<ChordOptions>): Params<ChordOptions> {
  const { chart } = params;
  chart.axis(false);
  return params;
}

/**
 * legendéç½®
 * @param params åæ°
 */
function legend(params: Params<ChordOptions>): Params<ChordOptions> {
  const { chart } = params;
  chart.legend(false);
  return params;
}

/**
 * tooltipéç½®
 * @param params åæ°
 */
function tooltip(params: Params<ChordOptions>): Params<ChordOptions> {
  const { chart, options } = params;
  const { tooltip } = options;

  chart.tooltip(tooltip);
  return params;
}

/**
 * coordinateéç½®
 * @param params åæ°
 */
function coordinate(params: Params<ChordOptions>): Params<ChordOptions> {
  const { chart } = params;
  chart.coordinate('polar').reflect('y');
  return params;
}

/**
 * nodeGeometryéç½®
 * @param params åæ°
 */
function nodeGeometry(params: Params<ChordOptions>): Params<ChordOptions> {
  // node view
  const { chart, options } = params;
  const { nodesData } = params.ext.chordData;
  const { nodeStyle, label, tooltip } = options;

  const nodeView = chart.createView();
  nodeView.data(nodesData);

  // é¢
  polygon({
    chart: nodeView,
    options: {
      xField: X_FIELD,
      yField: Y_FIELD,
      seriesField: NODE_COLOR_FIELD,
      polygon: {
        style: nodeStyle,
      },
      label,
      tooltip,
    },
  });
  return params;
}

/**
 * edgeGeometryéç½®
 * @param params åæ°
 */
function edgeGeometry(params: Params<ChordOptions>): Params<ChordOptions> {
  const { chart, options } = params;
  const { edgesData } = params.ext.chordData;
  const { edgeStyle, tooltip } = options;

  const edgeView = chart.createView();
  edgeView.data(edgesData);

  // edge
  const edgeOptions = {
    xField: X_FIELD,
    yField: Y_FIELD,
    seriesField: EDGE_COLOR_FIELD,
    edge: {
      style: edgeStyle,
      shape: 'arc',
    },
    tooltip,
  };
  edge({
    chart: edgeView,
    options: edgeOptions,
  });
  return params;
}

function animation(params: Params<ChordOptions>): Params<ChordOptions> {
  const { chart, options } = params;
  const { animation } = options;

  // åæ¶è®¾ç½®æ´ä¸ª view å¨ç»éé¡¹
  if (typeof animation === 'boolean') {
    chart.animate(animation);
  } else {
    chart.animate(true);
  }

  // ææç Geometry é½ä½¿ç¨åä¸å¨ç»ï¼åä¸ªå¾å½¢å¦æåºå«ï¼èªè¡è¦çï¼
  each(getAllGeometriesRecursively(chart), (g: Geometry) => {
    g.animate(animation);
  });

  return params;
}

/**
 * å¼¦å¾ééå¨
 * @param chart
 * @param options
 */
export function adaptor(params: Params<ChordOptions>) {
  // flow çæ¹å¼å¤çææçéç½®å° G2 API
  return flow(
    theme,
    transformData,
    coordinate,
    scale,
    axis,
    legend,
    tooltip,
    edgeGeometry,
    nodeGeometry,
    interaction,
    state,
    animation
  )(params);
}
